import { render } from "./CancelMandate.vue?vue&type=template&id=534d39ea&scoped=true"
import script from "./CancelMandate.vue?vue&type=script&lang=js"
export * from "./CancelMandate.vue?vue&type=script&lang=js"

import "./CancelMandate.vue?vue&type=style&index=0&id=534d39ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534d39ea"]])

export default __exports__